var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchAddress(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23805",
    "data-name": "Group 23805",
    transform: "translate(-1168 -485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "color",
    d: "M8.337,9h0L5.282,6.031a3.306,3.306,0,0,1-1.895.58,3.417,3.417,0,0,1-2.4-.96A3.228,3.228,0,0,1,0,3.317,3.356,3.356,0,0,1,3.387,0,3.344,3.344,0,0,1,6.75,3.317a3.318,3.318,0,0,1-.782,2.111L9,8.4,8.337,9ZM3.363.789a2.618,2.618,0,0,0-1.845.745A2.51,2.51,0,0,0,.758,3.34,2.582,2.582,0,0,0,3.363,5.892a2.617,2.617,0,0,0,1.844-.745,2.525,2.525,0,0,0,0-3.613A2.618,2.618,0,0,0,3.363.789Z",
    transform: "translate(1174 491)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_221",
    "data-name": "Ellipse 221",
    transform: "translate(1168 485)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 9.75,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchAddress);
export default __webpack_public_path__ + "static/media/search_address.81c575555c171e73ae3a573be7338e63.svg";
export { ForwardRef as ReactComponent };